export default 'accelerate'
